import tw from 'twin.macro'
import styled from 'styled-components'
import {Block} from 'baseui/block'

export const TextOB30 = styled(Block)`
  ${tw`font-secondary font-bold`}
  font-size: 30px;
  line-height: 38px;
`
export const TextOB24 = styled(Block)`
  ${tw`font-secondary font-bold`}
  font-size: 24px;
  line-height: 30px;
`
export const TextOB20 = styled(Block)`
  ${tw`font-secondary font-bold`}
  font-size: 20px;
  line-height: 25px;
`

export const TextGR24 = styled(Block)`
  ${tw`font-primary`}
  font-size: 24px;
  line-height: 28px;
`

export const TextGR20 = styled(Block)`
  ${tw`font-primary`}
  font-size: 20px;
  line-height: 23px;
`

export const TextGR16 = styled(Block)`
  ${tw`font-primary`}
  font-size: 16px;
  line-height: 19px;
`

export const TextGR14 = styled(Block)`
  ${tw`font-primary`}
  font-size: 14px;
  line-height: 16px;
`

export const ParagraphGR14 = styled(Block)`
  ${tw`font-primary`}
  font-size: 14px;
  line-height: 30px;
`

export const TextGB20 = styled(Block)`
  ${tw`font-primary font-bold`}
  font-size: 20px;
  line-height: 24px;
`

export const TextGB36 = styled(Block)`
  ${tw`font-primary font-bold`}
  font-size: 36px;
  line-height: 44px;
`
